/**
 * Backwards-compat wrapper around the new global useConfirm hook
 * (../hooks/useConfirm.jsx). Existing pages used:
 *
 *   const { confirm, ConfirmModal } = useConfirm();
 *   ... <>{ConfirmModal}</>
 *
 * The new hook is provider-based and returns the confirm function directly,
 * with the dialog mounted globally in App.js. This shim keeps old call sites
 * working without touching them: ConfirmModal is now a no-op fragment.
 */
import React from "react";
import { useConfirm as useNewConfirm } from "../hooks/useConfirm";

const NOOP_MODAL = <></>;

export function useConfirm() {
  const newConfirm = useNewConfirm();
  // Accept legacy options { actionLabel, cancelLabel } and forward to new API.
  function confirm(options = {}) {
    return newConfirm({
      title: options.title,
      description: options.description,
      confirmText: options.confirmText || options.actionLabel,
      cancelText: options.cancelText || options.cancelLabel,
      destructive: options.destructive,
      requireText: options.requireText,
    });
  }
  return { confirm, ConfirmModal: NOOP_MODAL };
}
